import React from "react";
import { Props } from "./types";

function OrderedListIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <line x1="10" y1="6" x2="21" y2="6" />
      <line x1="10" y1="12" x2="21" y2="12" />
      <line x1="10" y1="18" x2="21" y2="18" />
      <text
        x="2"
        y="8"
        fontSize="7"
        fill="currentColor"
        stroke="none"
        fontWeight="bold"
      >
        1
      </text>
      <text
        x="2"
        y="14"
        fontSize="7"
        fill="currentColor"
        stroke="none"
        fontWeight="bold"
      >
        2
      </text>
      <text
        x="2"
        y="20"
        fontSize="7"
        fill="currentColor"
        stroke="none"
        fontWeight="bold"
      >
        3
      </text>
    </svg>
  );
}

export { OrderedListIcon };
